import React from "react";
import PropTypes from 'prop-types';

const Alert = (props) => {
	const firstCapital =(word)=>{
		let firstLetter = word.charAt(0).toUpperCase()
		let restLetters = word.slice(1,word.length)
		return firstLetter+restLetters;
	}
	return (
		props.alert && <div
			className={`alert alert-${props.alert.type} fade show absolute`}
			role="alert"
		>
			<strong>{firstCapital(props.alert.type)}</strong> | {props.alert.msg}
		</div>
	);
};

Alert.propTypes = {
	alert: PropTypes.object || PropTypes.null
}

export default Alert;
